/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreatePartnerAccountCommand } from '../models/CreatePartnerAccountCommand';
import type { DeletePartnerAccountCommand } from '../models/DeletePartnerAccountCommand';
import type { GetPartnerAccountByIdQuery } from '../models/GetPartnerAccountByIdQuery';
import type { GetPartnerAccountInvitationLinkCommand } from '../models/GetPartnerAccountInvitationLinkCommand';
import type { ListPartnerAccountsQuery } from '../models/ListPartnerAccountsQuery';
import type { PartnerAccountInvitationLinkViewModel } from '../models/PartnerAccountInvitationLinkViewModel';
import type { PartnerAccountViewModel } from '../models/PartnerAccountViewModel';
import type { ResendPartnerAccountInvitationEmailCommand } from '../models/ResendPartnerAccountInvitationEmailCommand';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class PartnerAccountsService {
    /**
     * List all partner accounts
     * @param requestBody
     * @returns PartnerAccountViewModel Success
     * @throws ApiError
     */
    public static postApiPartnerAccountsListPartnerAccounts(
        requestBody?: ListPartnerAccountsQuery,
    ): CancelablePromise<Array<PartnerAccountViewModel>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/partner-accounts/list-partner-accounts',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Invalid access token`,
            },
        });
    }
    /**
     * Get partner account by ID
     * @param requestBody
     * @returns PartnerAccountViewModel Success
     * @throws ApiError
     */
    public static postApiPartnerAccountsGetPartnerAccountById(
        requestBody?: GetPartnerAccountByIdQuery,
    ): CancelablePromise<PartnerAccountViewModel> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/partner-accounts/get-partner-account-by-id',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Invalid access token`,
            },
        });
    }
    /**
     * Create a new partner account
     * @param requestBody
     * @returns PartnerAccountViewModel Success
     * @throws ApiError
     */
    public static postApiPartnerAccountsCreatePartnerAccount(
        requestBody?: CreatePartnerAccountCommand,
    ): CancelablePromise<PartnerAccountViewModel> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/partner-accounts/create-partner-account',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Invalid access token`,
            },
        });
    }
    /**
     * Delete a partner account
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    public static postApiPartnerAccountsDeletePartnerAccount(
        requestBody?: DeletePartnerAccountCommand,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/partner-accounts/delete-partner-account',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Invalid access token`,
            },
        });
    }
    /**
     * Resend partner account invitation email
     * @param requestBody
     * @returns PartnerAccountViewModel Success
     * @throws ApiError
     */
    public static postApiPartnerAccountsResendPartnerAccountInvitationEmail(
        requestBody?: ResendPartnerAccountInvitationEmailCommand,
    ): CancelablePromise<PartnerAccountViewModel> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/partner-accounts/resend-partner-account-invitation-email',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Invalid access token`,
            },
        });
    }
    /**
     * Get partner account invitation link
     * @param requestBody
     * @returns PartnerAccountInvitationLinkViewModel Success
     * @throws ApiError
     */
    public static postApiPartnerAccountsGetPartnerAccountInvitationLink(
        requestBody?: GetPartnerAccountInvitationLinkCommand,
    ): CancelablePromise<PartnerAccountInvitationLinkViewModel> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/partner-accounts/get-partner-account-invitation-link',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Invalid access token`,
            },
        });
    }
}
